import React from "react";
import SummaryDetailsItem from "@/src/components/Form/Common/SummaryDetailsItem/SummaryDetailsItem";
import SummaryDetailsProps from "@/src/types/SummaryDetailsProps";

const SummaryDetailsDataLeak = ({ caseData }: SummaryDetailsProps) => {
  return (
    <>
      {!!caseData.contractNumber && <SummaryDetailsItem caseData={caseData} fieldPath={"contractNumber"} />}
    </>
  );
};

export default SummaryDetailsDataLeak;
